module.exports = __webpack_public_path__ + "img/img06.e4dd08ca.png";